// Based on https://github.com/jeremyblalock/jquery.clamp
// This plugin is modified by Borealis
(function($) {
	function mutableClamp($el, lines, moreText, lessText, charPerLine) {
		var text,
			lineHeight = parseInt($el.css('line-height')) + 1,
			maxHeight = lineHeight * lines,
			clampIsInitialised = $el.find('.clamp-hidden');


		$el.html(IMS.util.LinksUtil.transformURIsToHyperlinksInText($el.text()));
		if (_.isNaN(lineHeight) || $el.height() < maxHeight) {
			return;
		}
		text = $el.text();
		if (clampIsInitialised.length !== 0) {
			clampIsInitialised.find('button').remove();
			text = clampIsInitialised.text();
		}

		var $clampTop = $('<span class="clamp-visible"></span>'),
			$clampTopText = $('<span></span>'),
			$clampEllipsis = $('<span>... </span>'),
			$clampLink = $('<button type="button" class="show-more-btn btn btn-clear"></button>')
				.html(moreText),
			$clampBottom = $('<span class="clamp-hidden"></span>')
				.html(IMS.util.LinksUtil.transformURIsToHyperlinksInText(text) + ' ').hide(),
			$hideLinkTop = $('<button type="button" class="show-more-btn btn btn-clear"></button>').html(lessText),
			$hideLinkBottom = $('<button type="button" class="show-more-btn btn btn-clear"></button>').html(lessText);


		if ($el.height() / window.innerHeight > 0.35) {
			$clampBottom.prepend($hideLinkTop);
		}
		$el.text('');
		$clampBottom.append($hideLinkBottom);
		$clampTop.append($clampTopText, $clampEllipsis, $clampLink);
		$el.append($clampTop, $clampBottom);

		var textPerLineBreak = text.split('\n').slice(0, lines);
		var currentLength = 0;
		_.each(textPerLineBreak, function(singleLine) {
			currentLength += singleLine.length;
		});
		var finalLength = currentLength < lines * charPerLine ? currentLength : lines * charPerLine;

		$clampTopText.text(text.substring(0, finalLength - 1));
		$clampTopText.html(IMS.util.LinksUtil.transformURIsToHyperlinksInText($clampTopText.text()));

		$clampLink.on('click', function(e) {
			e.preventDefault();
			$clampTop.hide();
			$clampBottom.show();
		});
		$hideLinkTop.on('click', function(e) {
			e.preventDefault();
			$clampTop.show();
			$clampBottom.hide();
		});
		$hideLinkBottom.on('click', function(e) {
			e.preventDefault();
			$clampTop.show();
			$clampBottom.hide();
		});
	}

	$.fn.showMore = function(options) {
		var $el = this;
		if (options.moreText == null) {
			options.moreText = 'show more';
		}
		if (options.lessText == null) {
			options.lessText = options.lessText || 'show less';
		}
		$el.each(function() {
			mutableClamp($(this), options.lines, options.moreText, options.lessText, options.charsPerLine);
		});
		return $el;
	};

	$.fn.numberOfCharsPerLine = function() {
		var $el = this;
		var originalText = $el.text();
		var partialText = '',
			$clampTop = $('<span class="clamp-visible"></span>'),
			$clampTopText = $('<span></span>'),
			$clampEllipsis = $('<span>... </span>'),
			$clampLink = $('<button type="button" class="show-more-btn btn btn-clear"></button>')
				.html('Show&nbsp;more');

		$el.text('');
		$clampTop.append($clampTopText, $clampEllipsis, $clampLink);
		$el.append($clampTop);

		if (!$clampTop.height()) {
			$clampTopText.text(originalText);
			$clampEllipsis.remove();
			$clampLink.remove();
			return 0;
		}

		var baseHeight = $clampTop.height();
		/*
		Firefox do not know when to add a newline at this stage, therefor the while-loop will never end.
		This counter is a temporary workaround for firefox. the value '17' is based on results obtained with chrome.
		All of the Jquery custom clamp is to be replaced.
		 */
		var charCounter = 1;
		while ($clampTop.height() <= baseHeight && charCounter <= 17) {
			partialText += 'wwwww';
			$clampTopText.text(partialText);
			charCounter++;
		}

		$clampTopText.text(originalText);
		$clampEllipsis.remove();
		$clampLink.remove();
		return partialText.length - 5;
	}
})(jQuery);